export default "__VITE_ASSET__DJJT2yUc__"